import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const ReferredTo: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-neutral-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 12 13"
                            className="w-12 h-12 fill-white "
                            fill="none"
                        >
                            <path d="M9.1875 8.2373C8.85938 8.2373 8.625 8.49512 8.625 8.7998V11.4248C8.625 11.542 8.53125 11.6123 8.4375 11.6123H1.3125C1.19531 11.6123 1.125 11.542 1.125 11.4248V4.2998C1.125 4.20605 1.19531 4.1123 1.3125 4.1123H3.9375C4.24219 4.1123 4.5 3.87793 4.5 3.5498C4.5 3.24512 4.24219 2.9873 3.9375 2.9873H1.3125C0.585938 2.9873 0 3.59668 0 4.2998V11.4248C0 12.1514 0.585938 12.7373 1.3125 12.7373H8.4375C9.14062 12.7373 9.75 12.1514 9.75 11.4248V8.7998C9.75 8.49512 9.49219 8.2373 9.1875 8.2373ZM11.4375 0.737305H7.5C7.17188 0.737305 6.9375 0.995117 6.9375 1.2998C6.9375 1.62793 7.17188 1.8623 7.5 1.8623H10.0781L4.28906 7.65137C4.05469 7.88574 4.05469 8.2373 4.28906 8.44824C4.38281 8.56543 4.52344 8.6123 4.6875 8.6123C4.82812 8.6123 4.96875 8.56543 5.0625 8.44824L10.875 2.65918V5.2373C10.875 5.56543 11.1094 5.7998 11.4375 5.7998C11.7422 5.7998 12 5.56543 12 5.2373V1.2998C12 0.995117 11.7422 0.737305 11.4375 0.737305Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">Referred To</div>} key="1">
                <p className="mr-16 space-y-4">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    referred_to_in_unbold: !rxConfig?.referred_to_in_unbold,
                                });
                            }}
                        >
                            <span>Make the referred to bold</span>
                            <Checkbox checked={!rxConfig?.referred_to_in_unbold}></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['refer']: !rxConfig?.bullets_config?.['refer'],
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox checked={rxConfig?.bullets_config?.['refer']}></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.referred_to_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        referred_to_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            referred_to_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.referred_to_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        referred_to_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            referred_to_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default ReferredTo;
